import {
    ISlideRenderStateManager,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';
import { TtiReport } from '@src/slide/application/service/slide-render-state/plugin/plugin-tti-report';
import {
    SnapShotNotification,
} from '@src/slide/application/service/slide-render-state/plugin/plugin-snapshot-notification';

export function mountPlugins(SlideRenderStateManager: ISlideRenderStateManager): void {
    // 渲染性能数据上报
    new TtiReport(SlideRenderStateManager);
    // 截图服务钩子挂载（依赖于渲染完成时机）
    new SnapShotNotification(SlideRenderStateManager);
}
